import { Amplifier } from './Group/Amplifier';
import { Electronics } from './Group/Electronics';
import { ForceSensor } from './Group/ForceSensor';
import { LinearActuator } from './Group/LinearActuator';
import { MaterialSensor } from './Group/MaterialSensor';
import { MeasuringRoller } from './Group/MeasuringRoller';
import { SteeringFrame } from './Group/SteeringFrame';
import { TelemetrySystem } from './Group/TelemetrySystem';
import { TensionAccessories } from './Group/TensionAccessories';
import { TensionController } from './Group/TensionController';
import { WebGuideAccessories } from './Group/WebGuideAccessories';
import { WebGuideController } from './Group/WebGuideController';

export type TypeInterface =
    SteeringFrame
    | WebGuideController
    | TensionController
    | ForceSensor
    | Amplifier
    | LinearActuator
    | MaterialSensor
    | TensionAccessories
    | WebGuideAccessories
    | TelemetrySystem
    | MeasuringRoller
    | Electronics;

export enum Groups {
    SteeringFrame = 'steering_frame',
    LinearActuator = 'linear_actuator',
    WebGuideController = 'web_guide_controller',
    TensionController = 'tension_controller',
    ForceSensor = 'force_sensor',
    Amplifier = 'amplifier',
    MaterialSensor = 'material_sensor',
    TensionAccessories = 'tension_accessories',
    WebGuideAccessories = 'web_guide_accessories',
    TelemetrySystem = 'telemetry_system',
    MeasuringRoller = 'measuring_roller',
    Electronics = 'electronics',
}

export function getAllTypes() {
    return [
        SteeringFrame.ProductGroup,
        SteeringFrame.ProductLine,
        SteeringFrame.BasicProduct,
        WebGuideController.ProductGroup,
        WebGuideController.BasicProduct,
        TensionController.ProductGroup,
        TensionController.BasicProduct,
        ForceSensor.Series,
        ForceSensor.Size,
        ForceSensor.NominalForce,
        ForceSensor.Options,
        Amplifier.ProductGroup,
        Amplifier.BasicProduct,
        MaterialSensor.ProductGroup,
        MaterialSensor.ProductLine,
        MaterialSensor.BasicProduct,
        TensionAccessories.ProductGroup,
        WebGuideAccessories.ProductGroup,
        TelemetrySystem.ProductGroup,
        TelemetrySystem.Machine,
        TelemetrySystem.Ui,
        TelemetrySystem.Option,
        MeasuringRoller.Series,
        MeasuringRoller.Size,
        Electronics.ProductGroup,
        Electronics.BasicProduct,
    ];
}

export function getGroupForType(type: TypeInterface): Groups {
    const typeValue = '' + type;
    const dotIndex = typeValue.indexOf('.');

    return typeValue.substr(0, dotIndex) as Groups;
}
